import axios, { AxiosInstance } from "axios";
import { msalInstance } from "@/utils/auth-config";
import { AZURE_CLIENT_ID } from "@/constants/endpoints";
import { AppRoutes } from "@/constants/routes";

export const getAuthToken = () => {
  return localStorage.getItem("token") ?? "";
};

export const createAxios = (baseURL: string): AxiosInstance => {
  return axios.create({
    baseURL,
  });
};

const backendScope = `api://${AZURE_CLIENT_ID}/.default`;

export const getBackendAccessToken = async (): Promise<string | null> => {
  try {
    await msalInstance.initialize();
    const account = msalInstance.getActiveAccount();
    if (!account) {
      console.warn("No active account found");
      return null;
    }

    const response = await msalInstance.acquireTokenSilent({
      account,
      scopes: [backendScope],
    });

    return response.accessToken;
  } catch (error) {
    console.error("Error acquiring backend access token:", error);
    return null;
  }
};

let isLoggingOut = false;

const clearSessionAndRedirect = () => {
  if (isLoggingOut) return;
  
  isLoggingOut = true;
  
  localStorage.removeItem("msalToken");
  localStorage.removeItem("msalUser");
  localStorage.removeItem("token");
  sessionStorage.clear();
  
  msalInstance.setActiveAccount(null);
  
  if (globalThis.location.pathname !== AppRoutes.LOGIN) {
    globalThis.location.replace(AppRoutes.LOGIN);
  }
  
  setTimeout(() => {
    isLoggingOut = false;
  }, 1000);
};

export const createAxiosWithAuth = async (
  baseURL: string,
  token = "jwt",
): Promise<AxiosInstance> => {
  const instance = createAxios(baseURL);
  // "token_invalido_para_testing";

  const backendAccessToken = await getBackendAccessToken();
  
  instance.interceptors.request.use(
    (config: any) => {
      if (backendAccessToken) {
        config.headers["Authorization"] = `Bearer ${backendAccessToken}`;
      } else if (token) {
        config.headers["Authorization"] = `Bearer ${token}`;
      }
      return config;
    },
    (error: any) => {
      throw (error instanceof Error ? error : new Error(String(error)));
    },
  );

  // Response interceptor: manejar 401
  instance.interceptors.response.use(
    (response: any) => response,
    async (error: any) => {
      const status = error?.response?.status;
      
      if (status === 401 && !isLoggingOut) {
        // Limpiar sesión SIN usar métodos de MSAL que causen popups/redirects
        clearSessionAndRedirect();
      }
      
      throw (error instanceof Error ? error : new Error(String(error)));
    },
  );

  return instance;
};